import React from 'react';
import { useTranslation } from 'react-i18next';

const Step3ManagementContact = ({ formData = {}, onChange = () => {}, errors = {} }) => {
  const { t } = useTranslation();

  const baseInputClass =
    'w-full p-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-primaryAccent transition-colors duration-200 text-gray-800 dark:text-gray-100 bg-white dark:bg-gray-800';

  const getBorderClass = (hasError) =>
    hasError ? 'border-red-500' : 'border-gray-300 dark:border-gray-600';

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
        {t('partnerJoin.step3.title')}
      </h2>

      {/* Nama Penanggung Jawab */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step3.picName')} <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="picName"
          value={formData.picName || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(errors.picName)}`}
        />
        {errors.picName && (
          <p className="text-sm text-red-500 mt-1">{errors.picName}</p>
        )}
      </div>

      {/* Jabatan */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step3.picPosition')}
        </label>
        <input
          type="text"
          name="picPosition"
          value={formData.picPosition || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(false)}`}
        />
      </div>

      {/* Nomor Telepon Penanggung Jawab */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step3.picPhone')} <span className="text-red-500">*</span>
        </label>
        <input
          type="tel"
          name="picPhone"
          value={formData.picPhone || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(errors.picPhone)}`}
        />
        {errors.picPhone && (
          <p className="text-sm text-red-500 mt-1">{errors.picPhone}</p>
        )}
      </div>

      {/* Email Penanggung Jawab */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step3.picEmail')}
        </label>
        <input
          type="email"
          name="picEmail"
          value={formData.picEmail || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(false)}`}
        />
      </div>
    </div>
  );
};

export default Step3ManagementContact;
